import { useSearchParams } from 'react-router-dom';

export const useSearchParamsHook = () => {
  const [params, setParams] = useSearchParams();

  const getSearchParam = (key: string) => {
    return params.get(key);
  };

  const setSearchParam = (key: string, value: string | number) => {
    setParams(
      (params) => {
        params.set(key, value.toString());
        return params;
      },
      { replace: true },
    );
  };

  const removeSearchParam = (key: string) => {
    setParams(
      (params) => {
        params.delete(key);
        return params;
      },
      { replace: true },
    );
  };

  return { searchParams: params, getSearchParam, setSearchParam, removeSearchParam, setParams };
};
